import { render, staticRenderFns } from "./ProjectsPage.vue?vue&type=template&id=4020bc0c&scoped=true"
import script from "./ProjectsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsPage.vue?vue&type=style&index=0&id=4020bc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4020bc0c",
  null
  
)

export default component.exports